import { useState } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";
import useUser from "../../../core/user/useUser";
import { removeSubscription } from "../../../core/api/objects/objects";
import Button from "../../../ui-lib/components/Button/Button";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import useSharedObject from "../SharedObjectContext/useSharedObject";

export const CancelSubscriptionModal = ({
  objectId,
  fetchObjectSubscription,
}: {
  objectId: string;
  fetchObjectSubscription: () => Promise<void>;
}) => {
  const t = useTranslations();
  const { authenticatedRequest, config } = useUser();
  const { fetchObject } = useSharedObject();

  const [showCancelSubscriptionModal, setShowCancelSubscriptionModal] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onCancelSubscription = async () => {
    try {
      setIsLoading(true);
      await removeSubscription(objectId, authenticatedRequest);
      await fetchObject();
      setShowCancelSubscriptionModal(false);
      fetchObjectSubscription();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        text={t("Common:labels_deactivate_subscription")}
        variant="destructive"
        onClick={() => setShowCancelSubscriptionModal(true)}
        disabled={!config?.show.includes("CancelSubscriptions")}
      />
      <PrimeModal
        withFooter
        withHeader
        loading={isLoading}
        fixedWidth="576px"
        isOpen={showCancelSubscriptionModal}
        onClose={() => setShowCancelSubscriptionModal(false)}
        header={t("Common:labels_deactivate_subscription")}
        submitBtn={{
          text: t("Objects:label_dont_cancel_subscription"),
          onClick: () => setShowCancelSubscriptionModal(false),
        }}
        cancelBtn={{
          text: t("Objects:label_cancel_subscription"),
          variant: "destructive",
          onClick: onCancelSubscription,
        }}
      >
        <p>{t("Common:modal_cancel_subscription")}</p>
      </PrimeModal>
    </>
  );
};
